import { h, Component, Prop, Element } from '@stencil/core';

const sizes = {
  small: { height: 250, width: 250, cardWidth: 275 },
  medium: { height: 350, width: 350, cardWidth: 375 },
  large: { height: 500, width: 500, cardWidth: 525 },
};
@Component({
  tag: 'chart-container',
  styleUrl: 'chart-container.css',
})
export class ChartContainer {
  @Element() el: HTMLElement;

  @Prop() title: string;
  @Prop() subheader: string;
  @Prop() size: 'small' | 'medium' | 'large' = 'medium';
  @Prop() customWidth?: number;
  @Prop() customHeight?: number;
  @Prop() customCardWidth?: number;
  @Prop() customCardStyle?: { [key: string]: string } = {};
  @Prop() chartId: string;
  @Prop() kpis: { label: string; value: string }[];
  @Prop() kpisPosition: 'left' | 'top' = 'left';
  @Prop() adjustChartWidthForKpis: boolean;
  @Prop() hideAdornment: boolean = false;

  componentWillLoad() {
    if (!this.chartId) {
      console.error('chartId prop is required on component chart-container');
    }
  }

  render() {
    if (!this.chartId) return null;
    let cardWidth = this.customCardWidth ?? sizes[this.size].cardWidth;
    let chartWidth = this.customWidth ?? sizes[this.size].width;
    let chartHeight = this.customHeight ?? sizes[this.size].height;
    if (this.adjustChartWidthForKpis && this.kpis?.length && this.kpisPosition === 'left') {
      chartWidth -= 50;
      chartHeight -= 30;
    }

    let dataContainerPosition = "";
    let kpiContainerPosition = "";
    if(this.kpisPosition === 'top'){
      dataContainerPosition = "chart-container-data-container-top";
      kpiContainerPosition = "chart-container-kpi-container-top";
    }

    return (
      <udp-ambient-card width={`${cardWidth}px`} style={this.customCardStyle} hideAdornment={this.hideAdornment}>
        <div class="header">
          <unity-typography variant="h3">{this.title}</unity-typography>
          <unity-typography>{this.subheader}</unity-typography>
        </div>
        <div class={`chart-container-data-container ${dataContainerPosition}`}>
          {this.kpis?.length ? (
            <div class={`chart-container-kpi-container ${kpiContainerPosition}`}>
              {this.kpis.map(kpi => (
                <chart-kpi {...kpi} />
              ))}
            </div>
          ) : (
            ''
          )}
          {this.adjustChartWidthForKpis ? <div class="chart-container-spacer"/> : ''} 
            <div id={this.chartId} style={{ height: `${chartHeight}px`, width: this.kpisPosition === 'top' ? '100%' : `${chartWidth}px`, float: 'right' }}></div>
          </div>
      </udp-ambient-card>
    );
  }
}
